import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography } from '@material-ui/core';
import NowPlaying from './NowPlaying';
import Playlist from './Playlist';
import DetectMeeting from './DetectMeeting';
import Visible from '../../components/Visible';
import { playNow } from '../../redux/draft';

const ActionPanel = () => {
  const dispatch = useDispatch();
  const timecardStatus = useSelector((state) => state.timecard?.status);
  const timecardId = useSelector((state) => state.timecard?.timecardId);
  const draft = useSelector((state) => state.draft);
  const [view, setView] = useState('playlist');

  useEffect(() => {
    if (draft.id && view == 'playlist') setView('playing');
    if (!draft.id && view == 'playing') setView('playlist');
  }, [draft]);

  return (
    <div>
      <Visible mdUp>
        <div
          style={{
            overflowY: 'scroll',
            maxHeight: 'calc(100vh - 275px)',
          }}
        >
          {timecardStatus === 'DRAFT' ? (
            view == 'playing' ? (
              <NowPlaying draft={draft} />
            ) : (
              <>
                <DetectMeeting />
                <Playlist
                  onPlayNow={(item, type) => {
                    setView('playing');
                    dispatch(playNow(item, timecardId, type));
                  }}
                />
              </>
            )
          ) : (
            ''
          )}
        </div>
      </Visible>
      <Visible smDown>
        <div>
          {timecardStatus === 'DRAFT' ? (
            view == 'playing' ? (
              <NowPlaying draft={draft} />
            ) : (
              <>
                <DetectMeeting />
                <Playlist
                  onPlayNow={(item, type) =>
                    dispatch(playNow(item, timecardId, type))
                  }
                />
              </>
            )
          ) : (
            ''
          )}
        </div>
      </Visible>
      {timecardId && timecardStatus != 'DRAFT' && (
        <Typography variant="h5" style={{ textAlign: 'center', marginTop: 50 }}>
          Playlist not available <br />
          for submitted timecards
        </Typography>
      )}
    </div>
  );
};
export default ActionPanel;
